module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_1.9dd00905.jpg";